module.exports = __webpack_public_path__ + "static/media/small_cash.a85bc880.png";